export default __webpack_public_path__ + "static/slices-504bf98bdc8ed4ff7de3eb4b008a4010.png";